import React from 'react';
import './CloseIcon.scss';

const CloseIcon = ({ close }) => (
  <div className="close-icon" onClick={() => close()}>
    +
  </div>
);

export default CloseIcon;
